export const CheckBoxFilled = () => {
  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7305_102258)">
        <rect x="0.5" width="34" height="34" rx="4" fill="#090B1F" />
        <path
          d="M14.4501 24.9496L28.9001 10.4996L26.7501 8.34961L14.4501 20.6496L8.5001 14.6996L6.3501 16.8496L14.4501 24.9496Z"
          fill="#F7B696"
        />
      </g>
      <defs>
        <clipPath id="clip0_7305_102258">
          <rect width="34" height="34" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
